// import axios from '../utils/request';
// import { filter } from 'ynf-core-engine/services';
// const { getDefaultQuerySchemaService } = filter;

import request from 'ynf-core-engine/request';

export default class DataLoader {
  constructor (props) {
    this.props = props;
    this.domainKey = '';
    this.serviceCode = '';
    this.billNo = '';
    this.tplId = '';
    this.baseUrl = '/mdf-node/qtmProxy'
  }

  getParams = (params) => {
    this.billNo = params.billNo;
    this.tplId = params.tplId;
    this.domainKey = params.domainKey;
    this.serviceCode = params.serviceCode;
    this.msgUtil = params.utils;
  }

  // 获取默认查询方案
  async getDefaultQuerySchema () {
    try {
      const res = await request({
        url: `${this.baseUrl}/ypd/bill/filter/getDefaultQuerySchema?feV=6&domainKey=${this.domainKey}&serviceCode=${this.serviceCode}`,
        method: 'post',
        data: {
          billNo: this.billNo,
          tplId: this.tplId
        }
      });
      const { code, data, message } = res;
      if (code === 200) {
        return data;
      } else {
        this.msgUtil.message.danger(message);
        console.error('获取默认查询方案失败', message);
        return [];
      }
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80132', '获取默认查询方案失败'));
    }
  }

  // 获取查询方案列表数据
  async getSolutionList () {
    try {
      const res = await request({
        url: `${this.baseUrl}/ypd/bill/filter/getAllQuerySchema?domainKey=${this.domainKey}&serviceCode=${this.serviceCode}`,
        method: 'post',
        data: {
          billNo: this.billNo,
          tplId: this.tplId
        }
      });
      const { code, data, message } = res;
      if (code === 200) {
        return data;
      } else {
        this.msgUtil.message.danger(message);
        console.error('获取查询方案列表数据失败', message);
        return [];
      }
    } catch {
      this.msgUtil.message.danger(lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8012D', '获取查询方案列表数据失败'));
    }
  }

  // 获取用户权限
  async checkAuthByCode () {
    try {
      const res = await request({
        url: `${this.baseUrl}/ypd/user/checkAuthByCode?terminalType=1&code=userdef_filterItem,userdef_schemaSetting&serviceCode=${this.serviceCode}`,
        method: 'get',
        headers: {
          'domain-key': this.domainKey
        }
      });
      try {
        const { code, message } = res;
        if (code !== 200) {
          this.msgUtil.message.danger(message || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A800E1', '无权限'));
        }
      } catch (error) {
        this.msgUtil.message.danger(error);
      }
      return res;
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80134', '获取用户权限失败'));
    }
  }

  // 删除方案
  async delSolution (solutionId) {
    try {
      const res = await request({
        url: `${this.baseUrl}/ypd/bill/filter/deleteQuerySchema?domainKey=${this.domainKey}&serviceCode=${this.serviceCode}`,
        method: 'post',
        data: {
          billNo: this.billNo,
          tplId: this.tplId,
          solutionId
        }
      });
      const { code, message } = res;
      if (code === 200) {
        this.msgUtil.message.success(message);
      } else {
        this.msgUtil.message.danger(message);
      }
      return res;
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8012E', '删除方案失败'));
    }
  }

  // 设为默认
  async setDefaultFilter (solutionId) {
    try {
      const res = await request({
        url: `${this.baseUrl}/ypd/bill/filter/setDefaultQuerySchema?domainKey=${this.domainKey}&serviceCode=${this.serviceCode}`,
        method: 'post',
        data: {
          billNo: this.billNo,
          tplId: this.tplId,
          solutionId
        }
      });
      const { code, message } = res;
      if (code === 200) {
        this.msgUtil.message.success(message);
      } else {
        this.msgUtil.message.danger(message);
      }
      return res
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80136', '设为默认失败'));
    }
  }

  // 新增/编辑方案
  async saveSolution (requestData) {
    try {
      const res = await request({
        url: `${this.baseUrl}/ypd/bill/filter/saveQuerySchema?domainKey=${this.domainKey}&serviceCode=${this.serviceCode}`,
        method: 'post',
        data: requestData
      });
      return res;
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8012F', '方案保存失败'));
    }
  }

  // 自定义过滤条件列表
  async getCustMetaFilterItems (filterId) {
    try {
      const res = await request({
        url: `/mdf-node/uniform/filterDesign/getCustMetaFilterItems?terminalType=1&serviceCode=${this.serviceCode}`,
        method: 'get',
        headers: {
          'domain-key': this.domainKey
        },
        params: {
          filtersId: filterId
        }
      });
      const { code, data } = res;
      if (code === 200) {
        return data;
      }
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80137', '自定义过滤条件列表获取失败'));
    }
  }

  // 新增过滤规则左侧树列表
  async getEntityInfoByBillNo (billno, busiObj) {
    try {
      const res = await request({
        url: `/mdf-node/uniform/report/getEntityInfoByBillNo?terminalType=1&serviceCode=${this.serviceCode}`,
        method: 'get',
        headers: {
          'domain-key': this.domainKey
        },
        params: {
          billno,
          busiObj
        }
      });
      const { code, data } = res;
      if (code === 200) {
        return data;
      }
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80133', '新增过滤规则失败'));
    }
  }

  // 编辑过滤项
  async getCustMetaFilterItemById (itemId) {
    try {
      const res = await request({
        url: `/mdf-node/uniform/filterDesign/getCustMetaFilterItemById?terminalType=1&serviceCode=${this.serviceCode}`,
        method: 'get',
        headers: {
          'domain-key': this.domainKey
        },
        params: {
          itemId
        }
      });
      const { code, data } = res;
      if (code === 200) {
        return data;
      }
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80130', '编辑过滤项失败'));
    }
  }

  // 删除过滤项
  async delCustMetaFilterItem (itemId) {
    try {
      const res = await request({
        url: `/mdf-node/uniform/filterDesign/delCustMetaFilterItem?terminalType=1&serviceCode=${this.serviceCode}`,
        method: 'get',
        headers: {
          'domain-key': this.domainKey
        },
        params: {
          itemId
        }
      });
      const { code, data } = res;
      if (code === 200) {
        return data;
      }
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80138', '删除过滤项失败'));
    }
  }

  // 新增过滤规则右侧运算符获取
  async getEnumMap (enumtype) {
    try {
      const res = await request({
        url: `/mdf-node/uniform/enum/getEnumMap?terminalType=1&serviceCode=${this.serviceCode}`,
        method: 'get',
        headers: {
          'domain-key': this.domainKey
        },
        params: {
          enumtype
        }
      });
      const { code, data } = res;
      if (code === 200) {
        return data;
      }
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80135', '运算符获取失败'));
    }
  }

  // 新增过滤规则底部校验接口
  async checkCondition (busiObj, postdata) {
    try {
      const res = await request({
        url: `/mdf-node/uniform/filterDesign/checkCondition?terminalType=1&serviceCode=${this.serviceCode}`,
        method: 'post',
        headers: {
          'domain-key': this.domainKey
        },
        params: {
          busiObj
        },
        data: postdata
      });
      const { code, data } = res;
      if (code === 200) {
        return data;
      }
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80131', '新增过滤规则校验失败'));
    }
  }

  // 新增过滤规则底部保存接口
  async saveCustMetaFilterItem (postdata) {
    try {
      const res = await request({
        url: `/mdf-node/uniform/filterDesign/saveCustMetaFilterItem?terminalType=1&serviceCode=${this.serviceCode}`,
        method: 'post',
        headers: {
          'domain-key': this.domainKey
        },
        data: postdata
      });
      const { code, data } = res;
      if (code === 200) {
        return data;
      }
    } catch (error) {
      this.msgUtil.message.danger(error || lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A80139', '新增过滤规则保存失败'));
    }
  }

  // saveBytoken
  async saveBytoken (serviceCode) {
    const res = await request({
      url: `/mdf-node/uniform/log-pub/rest/operation/saveBytoken?terminalType=1&serviceCode=${serviceCode}`,
      method: 'post',
      headers: {
        'domain-key': this.domainKey
      },
      params: {
        serviceCode
      }
    });
    const { code, data } = res;
    if (code === 200) {
      return data;
    }
  }
}